// extracted by mini-css-extract-plugin
export default {"googleButton":"google-login-button_googleButton__sDaiI","createUser":"google-login-button_createUser__hQ+3K"};